import React from 'react';
import { useTranslation } from 'react-i18next';

export const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <main className="min-h-full w-screen bg-cover bg-center bg-top sm:bg-top bg-sahara">
        <div className="max-w-7xl mx-auto px-8 py-16 text-center sm:px-6 sm:py-24 lg:px-16 lg:py-96">
          <h2 className="mt-2 text-4xl font-extrabold text-black tracking-tight sm:text-5xl">
            {t("error404")}
          </h2>
          <button className="mt-6" type="button">
            <a
              href="/"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-black text-opacity-75 bg-white bg-opacity-75 sm:bg-opacity-25 sm:hover:bg-opacity-50"
            >
              {t("goBackHome")}
            </a>
          </button>
        </div>
      </main>
    </>
  );
};

export default NotFoundPage;
